import type React from "react";
import { Trans, useTranslation } from "react-i18next";

import {
  type EnvironmentType,
  serviceENV as getCurrentEnvironment,
  isLocal,
  isTest,
} from "constants/env-constants";
import { HogesWebshopURL } from "constants/registration-links";

import { useDomainHandler } from "hooks/useDomainHandler";

import { InfoMessage } from "components/InfoMessage/InfoMessage";
import { Link } from "components/Link";

export const ExpiredLicensePage: React.FC = () => {
  const { t } = useTranslation("common");

  const currentEnv = getCurrentEnvironment() as EnvironmentType;
  const { getCustomSupportEmailByDomain } = useDomainHandler();

  return (
    <InfoMessage
      icon="fas fa-ban"
      dataCy="expired-license-notice"
      title={t("expiredLicenseNotice.title")}
    >
      <Trans
        components={{
          webshopLink: (
            <Link
              dataCy="expired-license-notice-webshop-link"
              external={!isTest() && !isLocal()}
              to={HogesWebshopURL[currentEnv]}
            />
          ),
          supportLink: <Link to={`mailto: ${getCustomSupportEmailByDomain()}`} external={true} />,
        }}
        i18nKey={"expiredLicenseNotice.message"}
        t={t}
      />
    </InfoMessage>
  );
};
